import {normalize, schema} from 'normalizr';

function normalizeDatos(myData) {

    const categoria = new schema.Entity('categorias', {}, {idAttribute: "id"});
    const producto = new schema.Entity('productos', {categoria: categoria}, {idAttribute: "codProducto"});
    const productoPromocion = new schema.Entity('producto_promocion', {producto: producto}, {idAttribute: "id"});
    const promocion = new schema.Entity('promociones', {producto_promocion: [productoPromocion]}, {idAttribute: "id"});
    const mySchema = [promocion];
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}

export default normalizeDatos;


// WEBPACK FOOTER //
// ./src/normalizers/normalizePromociones.js